import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded py-[16px] px-[24px] pb-[32px] w-[391px] bg-theme-grey" }
const _hoisted_2 = { class: "flex justify-center mb-4" }
const _hoisted_3 = { class: "flex-auto justify-center items-center mt-1" }
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Base = _resolveComponent("Base")!

  return (_openBlock(), _createBlock(_component_Base, null, {
    basecontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "text-theme-green mt-4",
              to: {
                name: 'Login'
              }
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Back", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-auto w-64" }, [
            _createElementVNode("div", { class: "text-2xl font-semibold text-white mt-0 pl-[12px] text-left" }, "Password Reset")
          ], -1))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-[16px] text-white text-center" }, " Enter your email to get further instructions ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
          ref: "forgotPassForm_"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.forgotPassForm.email.error_type))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mt-3 block label-text mb-1" }, " Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline",
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forgotPassForm.email.value) = $event)),
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['email'])))
            }, null, 544), [
              [_vModelText, _ctx.forgotPassForm.email.value]
            ]),
            (_ctx.forgotPassForm.email.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.forgotPassForm.email.error_message)
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ], 2),
          _cache[6] || (_cache[6] = _createElementVNode("button", { class: "mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px]" }, " CONFIRM ", -1))
        ], 544)
      ])
    ]),
    _: 1
  }))
}